module.exports = __webpack_public_path__ + "img/picNumber.29d46fb6.png";